<!--任务分配基本信息-->
<template>
  <div class="app-container">
    <div class="box-card">
      <div class="content-title"><span class="title-icon"></span><span class="title-details">任务分配基本信息</span></div>
      <div slot="content">
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :disabled="openLook"
          :showBtn="showBtn"/>
      </div>
      <folded-panel infoName="工作内容">
        <div slot="content">
          <edit-data-table
            :showNumber="editTable.showNumber"
            :head="editTable.bsPerformanceCompositionList"
            :editable="true"
            :config="{ trigger: 'click', mode: 'cell' }"
            :showAdd="editTable.showAdd"
            :border="true"
            :data.sync="tableData"
            ref="delRew"
            height=""
          >
            <template #toolbar="scope">
              <el-popover :ref="scope.row.id" placement="top" width="180">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
                  <el-button
                    :loading="delLoading"
                    type="primary"
                    size="mini"
                    @click="subDelete(scope.row.id,scope.row)">确定
                  </el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>

                <!-- <el-button slot="reference" type="danger" icon="el-icon-delete" size="mini"/> -->
              </el-popover>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <div class="button">
        <el-button class="btn-submit" @click="submit">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import FoldedPanel from "@/components/FoldedPanel"
  import "@/components/dynamic-form"
  import '@/components/EditDataTable'
  import DataTableMixin from '@/mixins/DataTableMixin'

  import {
    add,
    edit,
    delForm,
    queryById
  } from '@/api/bill/taskAssignment/index.js'

  export default {
    name: "NewCustomer",
    components: {
      FoldedPanel,
    },
    mixins: [DataTableMixin],
    data() {
      return {
        delLoading: false,
        tableData: [],
        formConfig: {
          formItemList: [
            // 项目号	文本
            {
              type: "input",
              key: "projectId",
              label: "项目号",
              value: "",
              // disabled: true,
              span: 8,
            },
            // 分配日期	日期
            {
              span: 8,
              label: '分配日期',
              key: 'allocationTime',
              type: 'date',
              placeholder: '请选择报销日期',
              rules: {
                required: true, message: '不能为空', trigger: 'blur'
              }
            },
            // 任务接受人	基础资料《员工》
            {
              label: '任务接受人',
              key: 'taskRecipient',
              type: 'databox',
              span: 8,
              props: {
                label: 'name',
                value: 'id'
              },
            // /bs-person/getList
            // 人员列表
              url: '/bs-person/getList',
              tableColumn: [
                {
                  property: "number",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,number,name'},
              multiple: false,
              rules: {
                required: true, message: '不能为空', trigger: 'change'
              }
            },
            // 项目节点	基础资料《项目节点》
            {
              label: '项目节点',
              key: 'projectNode',
              type: 'databox',
              span: 8,
              props: {
                label: 'name',
                value: 'id'
              },
              // /bsProjectNode
              // 详情列表
              url: '/bsProjectNode',
              tableColumn: [
                {
                  property: "number",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,number,name'},
              multiple: false,
              rules: {
                required: true, message: '不能为空', trigger: 'change'
              }
            },
            // 里程碑节点	基础资料《里程碑节点》
            {
              label: '里程碑节点',
              key: 'milestoneNode',
              type: 'databox',
              span: 8,
              props: {
                label: 'name',
                value: 'id'
              },
              // /bsMilestoneNode
              // 详情列表
              url: '/bsMilestoneNode',
              tableColumn: [
                {
                  property: "number",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,number,name'},
              multiple: false,
              rules: {
                required: true, message: '不能为空', trigger: 'change'
              }
            },
            // 完成	Checkbox	默认为“N”，不可编辑
            {
              span: 8,
              type: "radio",
              label: "是否完成",
              value: "N",
              button: false,
              border: false,
              disabled: true,
              key: "completeState",
              options: [
                {
                  value: "N",
                  label: "未完成",
                  disabled: false
                },
                {
                  value: "Y",
                  label: "完成",
                  disabled: false
                }
              ],
            },
            // 备注
            {
              span: 24,
              type: "input",
              key: "remark",
              label: "备注",
              disable: false,
              subtype: 'textarea',
              readonly: false,
              value: "",
              placeholder: "请输入备注",
              rules: [
                // {
                //   required: true,
                //   message: "不能为空",
                //   trigger: "blur"
                // }
              ]
            }
          ]
        },
        showBtn: false,
        openLook: false,
        form: {},
        editTable: {
          showNumber: true,
          enableEdit: true,
          showAdd: true,
          bsPerformanceCompositionList: [
            // 任务节点编号	文本
            {
              label: '任务节点编号',
              prop: 'taskNodeCode',
              editRender: {type: 'date', name: 'ElInput'}
            },
            // 任务内容	文本
            {
              label: '任务内容',
              prop: 'taskContent',
              editRender: {type: 'date', name: 'ElInput'}
            },
            // 任务汇报	按钮
            {
              label: '任务汇报',
              prop: 'taskReport',
              editRender: {type: 'date', name: 'ElInput'}
            },
            // 任务分解	按钮
            {
              label: '任务分解',
              prop: 'taskDecomposition',
              editRender: {type: 'date', name: 'ElInput'}
            },
            // 任务状态	下拉框：进行中、已分配、已完成
            {
              label: '任务状态',
              prop: 'taskState',
              editRender: {
                type: 'default',
                name: 'ElSelect',
                options: [
                  {value: '进行中', label: '进行中'},
                  {value: '已分配', label: '已分配'},
                  {value: '已完成', label: '已完成'},
                ]
              }
            },            // 备注	文本
            {
              label: '备注',
              prop: 'remark',
              editRender: {
                type: 'textarea',
                name: 'ElInput',
              }
            }

          ],
        },
        isAdd: true,
      }
    },
    created() {
      const data = this.$route.query;
      this.isAdd = data.isAdd;
      if (!this.isAdd || this.isAdd === "false") {
        const id = data.id;
        queryById(id).then(res => {
          if (res.code === 200) {
            const data = res.data;
            console.log('data',data);
            this.form = data.bizTaskAllocation;
            this.form.taskRecipient = {id: data.bizTaskAllocation.taskRecipient, name: data.bizTaskAllocation.bsPerson.name};
            this.form.projectNode = {id: data.bizTaskAllocation.projectNode, name: data.bizTaskAllocation.bsProjectNode.name};
            this.form.milestoneNode = {id: data.bizTaskAllocation.milestoneNode, name: data.bizTaskAllocation.bsMilestoneNode.name};
            this.tableData = data.bizJobContentList;
          }
        });
      }
    },
    methods: {
      submit() {
        this.form.taskRecipient = this.form.taskRecipient.id;
        this.form.projectNode = this.form.projectNode.id;
        this.form.milestoneNode = this.form.milestoneNode.id;
        this.form.allocationTime = new Date(this.form.allocationTime).getTime();
        if (!this.isAdd) {
          edit({
            bizTaskAllocation: this.form,
            bizJobContentList: this.tableData,
          }).then(res => {
            this.$message.success("修改成功！")
          })
        } else {
          add({
            bizTaskAllocation: this.form,
            bizJobContentList: this.tableData,
          }).then(res => {
            this.$message.success('保存成功！')
          })
        }
        this.$router.push('/bill/taskAssignment')
      },
      cancel() {
        this.$router.push('/bill/taskAssignment')
      },
      // 绩效组成删除
      subDelete(id, scope) {
        if (!id) {
          this.$refs.delRew.deleteRows(scope);
        }
        delForm(id).then(res => {
          if (res.code === 200) {
            this.$refs[id].doClose();
            this.$notify({
              title: '删除成功',
              type: 'success',
              duration: 2500
            });
            this.tableData.splice(scope.$index, 1);
          }
        });
      }
    }

  }
</script>

<style lang="scss" scoped>
  .app-container {
    .box-card {
      background-color: #fff;
      padding: 20px 30px 20px 30px;
      border-radius: 10px;

      .content-title {
        height: 40px;
        background-color: #e7eff6;
        padding-left: 20px;
        overflow: hidden;

        .title-icon {
          display: inline-block;
          margin-top: 8px;
          width: 6px;
          height: 24px;
          background-color: #1369a8;
          margin-right: 14px;
        }

        .title-details {
          overflow: hidden;
          line-height: 20px;
          display: inline-block;
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
          font-family: SourceHanSansSC-regular;
        }
      }

      .button {
        padding-top: 20px;
        text-align: right;

        .btn-submit {
          width: 80px;
          height: 38px;
          background: #1369a8;
          color: white;
        }

        .btn-cancel {
          width: 80px;
          height: 38px;
          background: #fff;
        }
      }
    }
  }
</style>
